import { IconButton, IconButtonProps } from '@mui/material'
import React from 'react'

const IconButtonWrapper: React.FC<IconButtonProps> = ({ ...props }) => (
  <IconButton {...props} />
)

export default IconButtonWrapper
